<template>
	<div class="home page">
		<img src="/img/rust.png">

		<h1>Welcome to the official website of RageCrew Gaming & Community</h1>

		<h2>RageCrew Servers - modded to perfection</h2>

		<!-- <p>RageCrew is an extremely action packed server. The so called "One Grid" is specific map type, which offers a really tiny map having constant action and pvp. If you are new to this, you will have a hard time finding a spot for your first base, getting your first loot and especially finding your first gun. Once you progressed a little further, things start to get a little easier. Caution: You will run into an enemy almost all of the time. We have many custom and some vanilla monuments. The goal is to survive and progress on a tiny map and eventually become the king of the map.</p> -->
	</div>
</template>

<script>
export default {
	name: "Home",
};
</script>


<style lang="scss">
.home {
	text-align: center;
	height: 100%;
	// padding-top: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	flex-direction: column;

	h1 {
		margin-bottom: 5px;
	}

	h2 {
		margin: 0px;
		margin-bottom: 25px;
		margin-top: 20px;
		font-weight: 400;
		opacity: 0.6;
		font-size: 21px;
	}

	p {
		margin: 5px;
		font-weight: 300;
		text-align: justify;
	}

	@media screen and (max-width: 1200px) and (orientation: portrait) {
		h1 {
			font-size: 6vw;
		}

		h2 {
			margin-top: 2vw;
			font-size: 3.5vw;
		}
	}
}
</style>
